// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"eac206c9","239":"5491b2ce","355":"d844c44e","389":"5ccc9ea0","732":"a38800b4","857":"1885f278","977":"cfa13509"}[chunkId] + ".chunk.js";
};